import React from "react";
import { Query } from 'react-apollo';
import { Form, Row, Button, Select, Col, Icon } from 'antd'; 
import { getBranchs, getBranchsByUser } from '../../../graphql/query/branch';
import formItemLayout from "../../../const/form/formItemLayout"; 
import AddButton from "../../common/AddButton";
const Option = Select.Option;

function Branch({data1, setData, handleInput, width, profile}){
    if(profile !== undefined && profile[0])return(
        <Query 
            query={profile[0].label !== "User" ? getBranchs : getBranchsByUser } 
            variables={{ user: localStorage.getItem('@Ossel:userid') }}
        >
            {({ loading, error, data, refetch }) => {
                return(
                    <Form.Item 
                        {...formItemLayout} 
                        label={"Filiais"} 
                        style={{marginTop: 25}}
                        hasFeedback
                        required={true}
                    >
                        <Row>
                            <Col xs={24} sm={24} md={18} lg={18} xl={18}>
                                {
                                    profile[0].label !== "User" ?
                                        <Select
                                            showSearch
                                            placeholder="Selecione uma Filial"
                                            optionFilterProp="children"
                                            onChange={e => handleInput(e, "branch", data1, setData)}
                                            value={data1.branch}
                                            style={{width: "100%"}}
                                            filterOption={(input, option) => option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
                                        >
                                            {data && data.branchs && data.branchs.map(b => {
                                                return(
                                                    <Option key={b._id} value={b._id}>{b.name}</Option>
                                                )
                                            })}
                                        </Select>
                                    :
                                        <Select
                                            showSearch
                                            placeholder="Selecione uma Filial"
                                            optionFilterProp="children"
                                            onChange={e => handleInput(e, "branch", data1, setData)}
                                            value={data1.branch}
                                            style={{width: "100%"}}
                                            filterOption={(input, option) => option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
                                        >
                                            {data && data.branchsByUser && data.branchsByUser.map(b => {
                                                return(
                                                    <Option key={b._id} value={b._id}>{b.name}</Option>
                                                )
                                            })}
                                        </Select>
                                }
                            </Col>
                            <Col xs={24} sm={24} md={6} lg={6} xl={6}>
                                { profile[0].label !== "User" ? <AddButton body={"ADD_BRANCH"}/> : null }
                                <Button 
                                    type="primary" 
                                    shape="circle" 
                                    style={{marginLeft: 10}}
                                    onClick={() => refetch()}
                                >
                                    <Icon type="reload" style={{paddingBottom: 5}}/>
                                </Button>
                            </Col>
                        </Row>
                    </Form.Item>
                )
            }}
        </Query>
    )
    else return null
}

export default Branch;


// WEBPACK FOOTER //
// ./src/components/common/selects/Branch.jsx